import { render, staticRenderFns } from "./CommonWritePuResult.vue?vue&type=template&id=aa8a9bbc&scoped=true"
import script from "./CommonWritePuResult.vue?vue&type=script&lang=js"
export * from "./CommonWritePuResult.vue?vue&type=script&lang=js"
import style0 from "./CommonWritePuResult.vue?vue&type=style&index=0&id=aa8a9bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8a9bbc",
  null
  
)

export default component.exports